require('./cardMoreOptionsButton.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @components
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKIconTask } = require('commonsComponents/OKIconTask');
// @ actions
const openYoungDocumentationActions = require('actions/openYoungDocumentation');
// @ utilities
const { removeCurrentSectionOption } = require('utilities/moreOptionsHelper');
const { cardValidationRules, isAdditionalCard } = require('utilities/accessHelperConditions/cards');
const { recordEventCardMoreOptionsFromCommons, recordLink } = require('utilities/tagging');
// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
// @constants
const {
    INACTIVE_STATUS_LIST,
    CANCELLED_STATUS,
    BLOCKED_STATUS
} = require('constants/contactCenter/cardStatus');
const { CARD_CREDIT, CARD_DEBIT, CARD_ECARD } = require('constants/index');
const {
    HIDE_VIRTUAL_ADDITIONAL_CARD_CC,
    PAY_LATER,
    R42_BENEFITS_AND_INSURANCE_SECTION,
    TOPUP_MOBILE,
    METALLIC_CARD
} = require('constants/flagBasedFeatures');
const { R42_CARD_OFF, R42_CARD_VIP } = require('constants/cardR42States');

require('./cardMoreOptionsButton.scss');

// @assets
const changePinIcon = require("assets/icons/change-pin.svg");
const cardControl = require("assets/icons/card-control-no-border-white.png");

class CardMoreOptionsButton extends React.Component {

    componentDidMount() {
        const {
            cardId,
            getCardDocumentationState,
            immCard,
            immOpenYoungDocumentation,
        } = this.props;

        if (immCard.get('isOpenYoung') && !immOpenYoungDocumentation.get('fetchDocumentationSuccess')) {
            getCardDocumentationState(cardId);
        }
    }

    onClickMoreOptions(eventAction) {
        const { immCard } = this.props;
        const tagEvent = immCard.get('tagging');
        recordEventCardMoreOptionsFromCommons(eventAction, tagEvent)
    }

    buildMoreOptions() {
        const {
            cardId,
            flagBasedFeatures,
            immCancelCardPayLater,
            immCard,
            immOpenYoungDocumentation,
            isNerudaUser,
        } = this.props;

        const isActive = immCard.get('active');
        const isR42cardValidType = immCard.get('isMetallic');
        const r42Metallic = flagBasedFeatures.get(METALLIC_CARD);
        let directMoneyEnabledFlag = false;
        let charityCardsEnabledFlag = false;
        let isPeriodicTransfer = false;
        let isOpenYoungAddDocumentationEnabled = false;
        let isPayLaterEnabled = false;
        let hideVirtualAdditionalCardForCC = false;
        let r42BenefitsAndInsuranceSection = false;

        if (!!flagBasedFeatures) {
            directMoneyEnabledFlag = isActive ? flagBasedFeatures.get("direct-money-enabled") : false;
            charityCardsEnabledFlag = flagBasedFeatures.get("solidarity");
            isPeriodicTransfer = flagBasedFeatures.get('hb-card-periodic-trfr-enabled') && isActive;
            isOpenYoungAddDocumentationEnabled = flagBasedFeatures.get('add-documentation-openyoung-enabled');
            isPayLaterEnabled = flagBasedFeatures.get(PAY_LATER);
            hideVirtualAdditionalCardForCC = flagBasedFeatures.get(HIDE_VIRTUAL_ADDITIONAL_CARD_CC);
            r42BenefitsAndInsuranceSection = flagBasedFeatures.get(R42_BENEFITS_AND_INSURANCE_SECTION);
        }
        const r42Validator = cardValidationRules.CARD_BENEFITS_AND_POLICIES.validator({ immCard })

        const options = [
            {
                visible: true,
                link: `/myprofile/cards/${cardId}/movements`,
                text: formatText('cardMoreOptions-movements'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-movements')),
            },
            {
                visible: true,
                link: `/myprofile/cards/${cardId}/details`,
                text: immCard.get('type') === CARD_DEBIT ? formatText('cardDetails-cardDetails_titleDebitCards') : formatText('cardMoreOptions-infoCardAndContract'),
                handleClick: () => this.onClickMoreOptions(immCard.get('type') === CARD_DEBIT ? formatText('cardDetails-cardDetails_titleDebitCards') : formatText('cardMoreOptions-infoCardAndContract')),
            },
            {
                visible: r42Validator,
                link: cardValidationRules.CARD_BENEFITS_AND_POLICIES.redirectURL({ immCard }),
                text: formatText('cardMoreOptions-benefitsAndPolicies'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-benefitsAndPolicies')),
            },
            {
                visible: charityCardsEnabledFlag && cardValidationRules.CHARITY_CARD.validator({ immCard }),
                link: `/myprofile/cards/${cardId}/ngo-detail`,
                text: formatText('cardMoreOptions-modifyNGOCardConfiguration'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-modifyNGOCardConfiguration')),
            },
            ...(__CONTACT_CENTER__ ? [{
                visible: cardValidationRules.CARD_PIN_RESET.validator({ immCard }) && isActive,
                link: `/myprofile/cards/${cardId}/pin-reset`,
                text: formatText('cardPinReset-pinReset')
            }] : []),

            {
                visible: (cardValidationRules.CARD_CHANGE_PAYMENT_METHOD.validator({ immCard, immFlagBasedFeatures: flagBasedFeatures })) && isActive,
                link: `/myprofile/cards/${cardId}/payment-method/change`,
                text: formatText('cardMoreOptions-changePaymentMethod'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-changePaymentMethod')),
            },
            {
                visible: isPayLaterEnabled && cardValidationRules.CARD_PAY_LATER.validator({ immCard }) && isActive,
                link: (
                    __CONTACT_CENTER__
                        ? cardValidationRules.CARD_PAY_LATER.redirectURL({ cardId, immCancelCardPayLater, __CONTACT_CENTER__ })
                        : `/myprofile/cards/${cardId}/pay-later`
                ),
                text: formatText('cardMoreOptions-payLater'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-payLater')),
            },
            {
                visible: directMoneyEnabledFlag && cardValidationRules.CARD_TRANSFER_MONEY.validator({ immCard }),
                link: `/myprofile/cards/${cardId}/transfer-money`,
                text: formatText('cardMoreOptions-transferMoney'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-transferMoney')),
            },
            {
                visible: cardValidationRules.CARD_MODIFY_LIMIT.validator({ immCard, isNerudaUser }) && isActive,
                link: `/myprofile/cards/${cardId}/modify-limit`,
                text: formatText('cardMoreOptions-modifyLimit'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-modifyLimit')),
            },
            {
                visible: cardValidationRules.CARD_SECURE_PAYMENT.validator({ immCard }) && isActive,
                link: `/myprofile/cards/${cardId}/secure-payment`,
                text: formatText('cardMoreOptions-securePayment'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-securePayment')),
            },
            {
                visible: cardValidationRules.CARD_PIN_CVV_REQUEST.validator({ immCard }) && isActive,
                link: `/myprofile/cards/${cardId}/request/pin`,
                text: formatText('cardMoreOptions-pinConsult'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-pinConsult')),
            },
            {
                visible: cardValidationRules.CARD_PIN_CHANGE.validator({ immCard }) && isActive,
                link: `/myprofile/cards/${cardId}/pin-change`,
                text: formatText('cardMoreOptions-pinChange'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-pinChange')),
            },
            {
                visible: cardValidationRules.CARD_PIN_CVV_REQUEST.validator({ immCard, isCVVRequest: true }) && isActive,
                link: `/myprofile/cards/${cardId}/request/cvv`,
                text: formatText('cardMoreOptions-cvvRequest'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-cvvRequest')),
            },
            {
                visible: cardValidationRules.CARD_BLOCK.validator({ immCard }),
                link: `/myprofile/cards/${cardId}/block`,
                text: formatText('cardMoreOptions-block'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-block')),
            },
            {
                visible: ((r42Metallic && isR42cardValidType) || (!isR42cardValidType)) && cardValidationRules.CARD_REPLACE.validator({ immCard }) && isActive && !(__CONTACT_CENTER__ && (immCard.get('isVirtualCredit') || immCard.get('isVirtualDebit'))),
                link: `/myprofile/cards/${cardId}/replace`,
                text: formatText('cardMoreOptions-replace'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-replace')),
            },
            {
                visible: cardValidationRules.CARD_STATEMENT_MOVEMENTS.validator({ immCard }) && isActive,
                link: `/myprofile/cards/${cardId}/statements`,
                text: formatText('cardMoreOptions-statements'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-statements')),
            },
            {
                visible: cardValidationRules.CARD_DEPOSIT_MONEY.validator({ immCard }),
                link: `/myprofile/cards/${cardId}/deposit-money`,
                text: formatText('cardMoreOptions-depositMoney'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-depositMoney')),
            },
            ...flagBasedFeatures.get(TOPUP_MOBILE) ? {
                visible: cardValidationRules.CARD_MOBILE_RECHARGE.validator({ immCard }),
                link: `/myprofile/cards/${cardId}/mobile-recharge`,
                text: formatText('cardMoreOptions-mobileRecharge'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-mobileRecharge')),
            } : [],
            {
                visible: cardValidationRules.CARD_CHARGE.validator({ immCard }),
                link: `/myprofile/cards/${cardId}/charge`,
                text: formatText('cardMoreOptions-chargeDischardge'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-chargeDischardge')),
            },
            {
                visible: isPeriodicTransfer && (
                    cardValidationRules.CARD_OPEN_YOUNG_MANAGEMENT.validator({ immCard }) ||
                    cardValidationRules.CARD_DOWNLOAD_PDF.validator({ immCard })
                ),
                link: `/myprofile/cards/${cardId}/periodic-loads`,
                text: formatText('breadcrumb-cardPeriodicLoads'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-cardPeriodicLoads')),
            },
            {
                visible: cardValidationRules.CARD_DOWNLOAD_PDF.validator({ immCard }),
                link: `/myprofile/cards/${cardId}/download-pdf`,
                text: formatText('cardMoreOptions-getVirtualDebitPdf'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-getVirtualDebitPdf')),
            },
            {
                visible: isOpenYoungAddDocumentationEnabled &&
                    cardValidationRules.CARD_OPEN_YOUNG_UPLOAD_DOCUMENTATION.validator({ immCard, immOpenYoungDocumentation }),
                link: `/myprofile/cards/${cardId}/upload-documentation`,
                text: formatText('cardMoreOptions-cardMoreOptions_uploadDocumentation'),
                handleClick: () => {
                    recordLink('tarjetas-mas opciones', 'adjuntar documentacion', 'tarjeta prepago open young');
                    this.onClickMoreOptions(formatText('cardMoreOptions-cardMoreOptions_uploadDocumentation'))
                },
            },

            ...(__CONTACT_CENTER__ ? [
                {
                    visible: cardValidationRules.MODIFY_CARD_ACCOUNT.validator({ immCard, isNerudaUser }),
                    link: `/myprofile/cards/${cardId}/modify-card-account`,
                    text: formatText('cardMoreOptions-modifyCardAccount')
                },
                {
                    visible: cardValidationRules.SEND_PIN.validator({ immCard }) && isActive,
                    link: `/myprofile/cards/${cardId}/send-pin`,
                    text: formatText('cardMoreOptions-sendPin')
                },
                {
                    visible: cardValidationRules.CARD_TRANSFER_TO_CHECKING_ACCOUNT_CC.validator({ immCard }),
                    link: `/myprofile/cards/${cardId}/transfer-money-to-checking-account`,
                    text: formatText('cardMoreOptions-transferMoneyToCheckingAccount'),
                },
                {
                    visible: cardValidationRules.CARD_REQUEST_ADDITIONAL.validator({ immCard, hideVirtualAdditionalCardForCC }) && isActive && !(__CONTACT_CENTER__ && (immCard.get('isVirtualCredit') || immCard.get('isVirtualDebit'))),
                    link: `/myprofile/cards/${cardId}/request-additional`,
                    text: formatText('cardMoreOptions-cardRequestAdditional'),
                }
            ] : []),

            {
                visible: cardValidationRules.CARD_REWARD.validator({ immCard }) && isActive,
                link: `/myprofile/cards/${cardId}/rewards`,
                text: formatText('cardMoreOptions-cardMoreOptions_rewards'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-cardMoreOptions_rewards')),
            },
        ];

        return removeCurrentSectionOption(options);
    }

    buildInactiveCardsMoreOptions() {
        const {
            cardId,
            flagBasedFeatures,
            immCard,
        } = this.props;
        const statusCard = immCard.get('cancelled') ? CANCELLED_STATUS : immCard.get('status');
        const isActive = immCard.get('active');
        const r42Metallic = flagBasedFeatures.get(METALLIC_CARD);
        const isR42cardValidType = immCard.get('isMetallic');
        const r42Validator = cardValidationRules.CARD_BENEFITS_AND_POLICIES.validator({ immCard })

        let options = [
            {
                visible: true,
                link: `/myprofile/cards/${cardId}/movements`,
                text: formatText('cardMoreOptions-movements')
            },
            {
                visible: true,
                link: `/myprofile/cards/${cardId}/details`,
                text: immCard.get('type') === CARD_DEBIT ? formatText('cardDetails-cardDetails_titleDebitCards') : formatText('cardMoreOptions-infoCardAndContract')
            },
            {
                visible: r42Validator,
                link: cardValidationRules.CARD_BENEFITS_AND_POLICIES.redirectURL({ immCard }),
                text: formatText('cardMoreOptions-benefitsAndPolicies')
            },
            {
                visible: ((r42Metallic && isR42cardValidType) || (!isR42cardValidType)) && statusCard === BLOCKED_STATUS && immCard.get('type') !== CARD_ECARD && !(__CONTACT_CENTER__ && (immCard.get('isVirtualCredit') || immCard.get('isVirtualDebit'))),
                link: `/myprofile/cards/${cardId}/replace`,
                text: formatText('cardMoreOptions-replace')
            },
            {
                visible: immCard.get('type') === CARD_CREDIT && !isAdditionalCard(immCard),
                link: `/myprofile/cards/${cardId}/statements`,
                text: formatText('cardMoreOptions-statements')
            },
            {
                visible: statusCard === BLOCKED_STATUS && immCard.get('type') !== CARD_ECARD && !immCard.get('isNerudaCard') && !immCard.get('isVanityCard') && !(__CONTACT_CENTER__ && (immCard.get('isVirtualCredit') || immCard.get('isVirtualDebit'))),
                link: `/myprofile/cards/${cardId}/request-additional`,
                text: formatText('cardMoreOptions-cardRequestAdditional'),
            },
            {
                visible: cardValidationRules.CARD_REWARD.validator({ immCard }) && isActive,
                link: `/myprofile/cards/${cardId}/rewards`,
                text: formatText('cardMoreOptions-cardMoreOptions_rewards'),
                handleClick: () => this.onClickMoreOptions(formatText('cardMoreOptions-cardMoreOptions_rewards')),
            },
        ];

        return removeCurrentSectionOption(options);
    }

    render() {
        const { flagBasedFeatures, immCard } = this.props;
        const isActive = immCard.get('active');
        const statusCard = immCard.get('cancelled') ? CANCELLED_STATUS : immCard.get('status');
        const moreOptions = (__CONTACT_CENTER__ && INACTIVE_STATUS_LIST.includes(statusCard)) ?
            this.buildInactiveCardsMoreOptions() : this.buildMoreOptions();
        const targetElement = (
            <div>
                <div className="hidden-xs">
                    <OKButton
                        modifier="ghost"
                        inverse={true}
                        rightIcon="icon-dropdown-abrir"
                        smallRightIcon={true}
                    >
                        <FormattedText value="cards-moreOptions" />
                    </OKButton>
                </div>
                <div className="visible-xs">
                    <OKIconTask activeHover={false} icon="icon-s-op-comp" type="standalone" style="dark-bg" />
                </div>
            </div>
        );

        const configLink = `/myprofile/cards/config/${immCard.get('cardId')}`;

        const configButton = (
            <span className="icon-preferences-header">
                <OKLink extraClass="buttons-base buttons-base--regular buttons-base--ghost-inverse" to={configLink}>
                   <img src={cardControl} className="card-more-options-button__img" /> 
                </OKLink>
            </span>
        );

        let tooltipConfig;
        let mobileTooltipConfig;

        if (immCard.get('isConfigurable') &&
            immCard.get('active') &&
            immCard.get('isOperative') &&
            flagBasedFeatures.get('card-control-enabled')) {
            tooltipConfig = (
                <div className="card-more-options-button__content-tooltip hidden-xs">
                    <OKTooltip
                        content="cardsConfig-tooltip"
                        modifier="dark-bg"
                        offset={[0, -10]}
                        target={configButton}
                    />
                </div>
            );
            mobileTooltipConfig = (
                <div className="card-more-options-button__content-config-tooltip visible-xs">
                    <OKButton autoHeight={true} modifier="link-ghost" to={configLink}>
                        <span className="card-more-options-button__link-security">
                            <i className="icon-preferencias" />
                            <FormattedText className="card-more-options-button__link-security-text" value="cardsConfig-tooltip" />
                        </span>
                    </OKButton>
                </div>
            );
        }
        const changePinLink = `/myprofile/cards/${immCard.get('cardId')}/request/pin`;
        const changePinButton = (!__CONTACT_CENTER__ && isActive && cardValidationRules.CARD_PIN_CVV_REQUEST.validator({ immCard })) && (

            <span className="icon-preferences-header">
                <OKLink extraClass="buttons-base buttons-base--regular buttons-base--ghost-inverse" to={changePinLink}>
                    <img src={changePinIcon} />
                </OKLink>
            </span>
        )

        const pinTooltipConfig = (!__CONTACT_CENTER__ && isActive && cardValidationRules.CARD_PIN_CVV_REQUEST.validator({ immCard })) && (
            <div className="card-more-options-button__content-tooltip hidden-xs">
                <OKTooltip
                    content="cardsConfig-pinTooltip"
                    modifier="dark-bg"
                    offset={[0, -10]}
                    target={changePinButton}
                />
            </div>
        );
        return (
            <React.Fragment>
                {mobileTooltipConfig}
                <span className="card-more-options-button">
                    <PopoverMenu
                        overflow={{ adjustX: true, adjustY: false }}
                        target={targetElement}
                        items={moreOptions}
                        hasArrow={false}
                        placement="bottom"
                    />
                    {pinTooltipConfig}
                    {tooltipConfig}
                </span>
            </React.Fragment>
        );
    }
}

CardMoreOptionsButton.propTypes = {
    cardId: PropTypes.string.isRequired,
    getCardDocumentationState: PropTypes.func.isRequired,
    immCancelCardPayLater: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    immOpenYoungDocumentation: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    isNerudaUser: PropTypes.bool.isRequired,
};

export default connect(
    state => ({
        immOpenYoungDocumentation: state.openYoungDocumentation,
        isNerudaUser: state.profile.get('isNerudaUser'),
    }),
    {
        getCardDocumentationState: openYoungDocumentationActions.getCardDocumentationState,
    }
)(CardMoreOptionsButton);
